import { Card, CardHeader, CardContent, Typography, Grid } from "@mui/material";
import Table from "./home/table";
import Header from "./home/header";
import React from "react";

const ProductSupplierTransactions = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Header />
      </Grid>
      <Grid item xs={12}>
        < Table />
      </Grid>
    </Grid>
  );
};

export default ProductSupplierTransactions;
